import * as React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link, useLocation } from 'react-router-dom';
import { ArrowRight, ShieldQuestion } from 'lucide-react';

import { fetchMyCertification } from '@/data/advisor-certification';

export default function NotPublicYetBanner() {
  const location = useLocation();

  const state = useQuery({
    queryKey: ['advisor-certification'],
    queryFn: fetchMyCertification,
    retry: false,
  });

  const data = state.data;
  if (!data?.has_profile || data.is_certified) return null;
  if (location.pathname.startsWith('/advisor/certification')) return null;

  const total = data.required_total || 0;
  const passed = data.required_passed || 0;

  return (
    <div
      className="mb-4 flex flex-wrap items-center gap-3 rounded-md border border-amber-300 bg-amber-50 px-4 py-2.5 text-sm"
      data-testid="not-public-yet-banner"
    >
      <ShieldQuestion className="h-4 w-4 shrink-0 text-amber-600" />
      <span className="flex-1">
        <strong>Your profile is not in the directory yet.</strong> Publish it
        and its public link works for anyone you send it to, but customers
        browsing the directory or signing up cannot find or choose you until
        BitSwan certifies you. Everything else here is yours to use.
      </span>
      <Link
        to="/advisor/certification"
        className="inline-flex items-center gap-1 whitespace-nowrap font-medium text-amber-800 underline"
        data-testid="not-public-yet-link"
      >
        {data.call
          ? 'Your call is booked'
          : data.training_complete
            ? 'Book your call'
            : `Training ${passed}/${total}`}
        <ArrowRight className="h-3 w-3" />
      </Link>
    </div>
  );
}
